import React, { Fragment } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import FOSOpinionPanel from '../../../../../ombudsman/FOSOpinionPanel';
import OmbudsmanAdvicePanel from '../../../../../ombudsman/OmbudsmanAdvicePanel';
import { FOSOpinion } from '../../../../../../types/signals-live';

type Props = {
  open: boolean;
  onClose: () => void;
  signalId: string;
  fosOpinion?: FOSOpinion | null;
};

const OmbudsmanAdvisorModal: React.FC<Props> = ({ open, onClose, signalId, fosOpinion }) => {
  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog as="div" className="relative z-50" onClose={onClose}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-200"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-150"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black/30" />
        </Transition.Child>

        <div className="fixed inset-0 z-50 overflow-y-auto p-6">
          <div className="flex min-h-full items-center justify-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-200"
              enterFrom="opacity-0 translate-y-2"
              enterTo="opacity-100 translate-y-0"
              leave="ease-in duration-150"
              leaveFrom="opacity-100 translate-y-0"
              leaveTo="opacity-0 translate-y-2"
            >
              <Dialog.Panel className="w-full max-w-5xl transform overflow-hidden rounded-2xl bg-white text-left align-middle shadow-xl">
                <div className="p-6">
                  <Dialog.Title className="text-xl font-semibold text-gray-900 mb-4">
                  Ombudsman Advisory Service
                  </Dialog.Title>

                  {/* FOS Outcome Prediction */}
                  <div className="mb-6">
                    <FOSOpinionPanel fosOpinion={fosOpinion} />
                  </div>

                  {/* Similar Decisions and narrative */}
                  {/* <div>
                    <OmbudsmanAdvicePanel signalId={signalId} />
                  </div> */}

                  <div className="mt-6 flex justify-end">
                    <button
                      type="button"
                      className="px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:text-gray-900 hover:border-gray-400"
                      onClick={onClose}
                    >
                      Close
                    </button>
                  </div>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
};

export default OmbudsmanAdvisorModal;

